import {useViewerStore} from "../store/store";
import { useEffect, useState } from 'react';


export interface AreChangesMadeResult {
    /** Have edits been made since the design (or its load) last changed? */
    areChangesMade: boolean;
    /** Is the currently selected design the original site (index -1)? */
    isOriginalSite: boolean;
}


export function useAreChangesMadeToDesign(): AreChangesMadeResult {
    const {
        selectedDesignIndex,
        designList,
        sceneViewer,
        isDesignLoading,
    } = useViewerStore((state) => ({
        selectedDesignIndex: state.selectedDesignIndex,
        designList: state.designList,
        sceneViewer: state.sceneViewer ,
        isDesignLoading: state.isDesignLoading,
    }));

    const [isOriginalSite, setIsOriginalSite] = useState<boolean>(
        selectedDesignIndex === -1,
    );

    const [designLength, setDesignLength] = useState<number>(designList.length);

    const [defaultSteps, setDefaultSteps] = useState<number>(
        (sceneViewer.stepNum ?? -1) + 1,
    );


    useEffect(() => {
        setIsOriginalSite(selectedDesignIndex === -1);

        if (designList.length !== designLength) {
            if (sceneViewer.stepArr) sceneViewer.stepArr.length = 0; // reset in-place
            setDesignLength(designList.length);
        }

        setDefaultSteps((sceneViewer.stepNum ?? -1) + 1);
    }, [selectedDesignIndex, isDesignLoading, designList.length]);

    const liveSteps = sceneViewer.stepNum !== undefined
        ? sceneViewer.stepNum + 1
        : undefined;

    const areChangesMade =
        liveSteps === undefined || liveSteps === defaultSteps ? false : true;

    return { areChangesMade, isOriginalSite };
}
